document.addEventListener('DOMContentLoaded', function() {  
  let ticking = false;

  function updateParallax() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    const isMobile = window.innerWidth <= 749;
    const speed = isMobile ? 0.02 : 0.05; // LESS parallax on mobile

    parallaxElements.forEach(element => {
      const rect = element.getBoundingClientRect();

      // Only apply parallax when element is in viewport
      if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
        const yPos = (window.scrollY - element.offsetTop) * speed;
        const img = element.querySelector('.parallax-image');

        if (img) {
          img.style.transform = `translate3d(0, ${yPos}px, 0)`;
        }
      }
    });

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });

    // Initial call
    updateParallax();
  }
});
